import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit } from "@angular/core";
import { DashboardService } from "./services/dashboard.service";
import { Router } from "@angular/router";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  form: FormGroup;

  sfondo: string;
  img1: string;
  img2: string;
  img3: string;

  tipologie: Array<any> = [];
  inEvidenza: Array<any> = [];

  constructor(
    private service: DashboardService,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {
    this.sfondo = "assets/img/img/body.jpg";
    this.img1 = "assets/img/img/ricondizionato.png";
    this.img2 = "assets/img/img/igienizzato.png";
    this.img3 = "assets/img/img/personalizzato.png";
  }

  async ngOnInit(): Promise<void> {
    this.form = this.service.creaFormGroupRicerca();
    const result = await this.service
      .ricerca<any>("veicolo/tipologia/", null)
      .toPromise();
    this.tipologie = result.data;

    this.inEvidenza = await this.service
      .ricerca<any>("veicolo/web/inevidenza", null)
      .toPromise();

    this.inEvidenza.forEach((p) => {
      if (p.foto && p.foto.length > 0) {
        this.service
          .getImage(
            `veicolo/${p.IDvcl}/web/download/immagine/`,
            p.foto[0].nomeFileFoto,
          )
          .subscribe((result1) => {
            if (result1) {
              const file = new Blob([result1], { type: "application/jpg" }),
                fileURL = window.URL.createObjectURL(file);

              p.imageToShow = this.sanitizer.bypassSecurityTrustUrl(fileURL);
              p.fileURL = fileURL;
            }
          });
      } else {
        this.service
          .getImage("veicolo/xxx/web/download/immagine/", "")
          .subscribe((result1) => {
            if (result1) {
              const file = new Blob([result1], { type: "application/jpg" }),
                fileURL = window.URL.createObjectURL(file);

              p.imageToShow = this.sanitizer.bypassSecurityTrustUrl(fileURL);
              p.fileURL = fileURL;
            }
          });
      }
    });
  }

  ricerca() {
    localStorage.setItem("orion-filtri-home", JSON.stringify(this.form.value));

    this.router.navigate(["/usati/"]);
  }
}
